import { Anchor } from '@mantine/core';

const FLOW_DOCS_URL = 'https://docs.newo.ai/docs/flows';
const SKILLS_DOCS_URL = 'https://docs.newo.ai/docs/skills';

export const hints = {
    flowSettings: (
        <>
            Flow settings determine the general details, default LLM model, and
            runner type of the Flow. A description of the Flow can be added, or
            the title can be changed.
            <Anchor href={FLOW_DOCS_URL} size="xs" target="_blank">
                here
            </Anchor>
            .
        </>
    ),
    skills: (
        <>
            Represents the logic of an agent (i.e., where you explain what the
            agent should do). Multiple skills can be added to create complex
            Intelligent Agents capable of handling many tasks. For more
            information on Skills, click{' '}
            <Anchor href={SKILLS_DOCS_URL} size="xs" target="_blank">
                here
            </Anchor>
            .
        </>
    ),
    skillSettings: (
        <>
            Skill settings determine the general details, LLM model, runner
            type, and result name of the Skill. These settings can be changed
            for each new skill to output the result to a different name (if
            needed) or change the result action. For more information on Skills,
            click{' '}
            <Anchor href={FLOW_DOCS_URL} size="xs" target="_blank">
                here
            </Anchor>
            .
        </>
    ),
    events: (
        <>
            Events to which a Skill is subscribed. Events are a service that
            links API calls from external systems. For example, an event can
            trigger when a user sends a Sandbox chat message. The triggered
            event activates the specified Skill, which initiates the
            agent&apos;s intended behavior. For more information on Event
            Subscriptions, click{' '}
            <Anchor href={SKILLS_DOCS_URL} size="xs" target="_blank">
                here
            </Anchor>
            .
        </>
    ),
    parameters: (
        <>
            A special kind of variable used in a function to refer to one of the
            pieces of data provided as input to the function. Parameters are
            generally used for more complex use cases and will be covered in the
            Newo.AI documentation for future use case examples.
        </>
    ),
    states: (
        <>
            Used for storing and issuing parameters within a given Flow
            Instance. Each time you publish your Flow, the associated values get
            wiped and return to their default. If you want your agent to
            remember which state the user is in after each publish, then User
            State can be used. In other words, through State, different Skills
            can exchange data. For more information on State, click{' '}
            <Anchor href={FLOW_DOCS_URL} size="xs" target="_blank">
                here
            </Anchor>
            .
        </>
    )
};
